<template>
    <div>
        <div class="has-text-centered"><i class="fa fa-plus bottom20 top8"></i></div>
        <!-- <drop class="cardDropForTrans" :class="{cardDropDragOver: dragging}" drag-over="handleDragOver" @dragenter="dragging=true" @dragend="dragging=false" @dragleave="dragging=false" @drop="doDrop">
            
        </drop> -->
    </div>
</template>

<script>
import { Drag, Drop } from 'vue-drag-drop'

export default {
    name: 'new-lister',
    components: {Drag, Drop},
    props: {
        listName: String,
    },
    data: function(){
        return {
            dragging: false,
            listIndex: this.$root.app.init.lists.length,
            itemIndex: 0
        }
    },
    methods: {
        moveItem: function(fromList, fromIndex, toList, toIndex){
            let item = this.$root.app.init.lists[fromList].items[fromIndex];  
            this.$root.app.init.lists.push(item)
            this.$root.app.init.lists[fromList].items.splice(fromIndex, 1);
            this.dragging = false
            
        },
        doDrop: function(data, event){
            this.moveItem(data.listIndex, data.itemIndex, this.listIndex, this.itemIndex);
        },
        go: function(url){
            alert('Open Create New List');
        }
    }
}
</script>